// API call for the Swap Curve widget. No JSX — keep as .ts.
// Fetches swap curve data for a set of swap block ids from the back end:
//   GET /Curves/ByBlocks?BlockIds=18107&BlockIds=18108
// The widget currently holds its entry in local component state (not a Zustand store), so this
// returns the curve(s) to the caller rather than writing to a store. See README.

import { fetchRequestWrapper } from "@/lib/utilities";
import { buildCurvesByBlocksUrl, SwapCurve } from "./swapCurveHelpers";

// GET the swap curve(s) for the given swap block ids. Returns [] for no ids (so the caller can
// avoid an empty call) and lets fetchRequestWrapper handle/raise transport errors.
export async function fetchSwapCurvesByBlocks(
  blockIds: number[],
  getAccessTokenSilently: Function,
): Promise<SwapCurve[]> {
  if (!blockIds || blockIds.length === 0) return [];

  const data = await fetchRequestWrapper(
    { url: buildCurvesByBlocksUrl(blockIds) },
    getAccessTokenSilently,
  );

  return (data as SwapCurve[]) ?? [];
}
